/**
 * Zustand Store for Notification Preferences
 */

import { create } from 'zustand';
import { api } from '../lib/api';
import type { NotificationPreference, UpdateNotificationPrefsFormData } from '../types/shifts';

interface NotificationPrefsState {
  preferences: NotificationPreference | null;
  loading: boolean;
  error: string | null;
  fetchPreferences: () => Promise<void>;
  updatePreferences: (data: UpdateNotificationPrefsFormData) => Promise<NotificationPreference>;
  clearError: () => void;
}

export const useNotificationPrefsStore = create<NotificationPrefsState>((set) => ({
  preferences: null,
  loading: false,
  error: null,

  fetchPreferences: async () => {
    set({ loading: true, error: null });
    try {
      const preferences = await api.getNotificationPreferences();
      set({ preferences, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
      throw error;
    }
  },

  updatePreferences: async (data) => {
    set({ loading: true, error: null });
    try {
      const updatedPrefs = await api.updateNotificationPreferences(data);
      set({ preferences: updatedPrefs, loading: false });
      return updatedPrefs;
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
      throw error;
    }
  },

  clearError: () => set({ error: null }),
}));
